var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoVotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#001C29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2 90H34.8c-4.2 0-7.5-3.4-7.5-7.5V52c0-4.2 3.4-7.5 7.5-7.5h30.5c4.2 0 7.5 3.4 7.5 7.5v30.5c0 4.1-3.4 7.5-7.6 7.5z",
    fill: "#061C28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2 100H44.8c-4.2 0-7.5-3.4-7.5-7.5V62c0-4.2 3.4-7.5 7.5-7.5h30.5c4.2 0 7.5 3.4 7.5 7.5v30.5c0 4.1-3.4 7.5-7.6 7.5z",
    fill: "url(#a-no-votes)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9 77.2H45.7c-.9 0-1.6-.7-1.6-1.6v-1.9c0-.9.7-1.6 1.6-1.6H75c.9 0 1.6.7 1.6 1.6v1.9c-.1.9-.8 1.6-1.7 1.6zM74.9 84.6H45.7c-.9 0-1.6-.7-1.6-1.6v-1.9c0-.9.7-1.6 1.6-1.6H75c.9 0 1.6.7 1.6 1.6V83c-.1.9-.8 1.6-1.7 1.6zM74.9 92.1H45.7c-.9 0-1.6-.7-1.6-1.6v-1.9c0-.9.7-1.6 1.6-1.6H75c.9 0 1.6.7 1.6 1.6v1.9c-.1.8-.8 1.6-1.7 1.6z",
    fill: "#08212D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 75.4H47l-.1.4h-.5l.8-2.2h.4l.8 2.2H48l-.2-.4zm-.7-.4h.5l-.3-.8-.2.8zM46.6 83.2V81h.8c.3 0 .5.1.6.2.1.1.2.3.2.4 0 .1 0 .2-.1.3l-.2.2c.1 0 .2.1.3.2.1.1.1.2.1.3 0 .2-.1.4-.2.5-.1.1-.3.2-.6.2h-.9v-.1zm.5-1.3h.3c.2 0 .3-.1.3-.3 0-.1 0-.2-.1-.2s-.1-.1-.3-.1H47v.6h.1zm0 .3v.6h.4c.1 0 .2 0 .2-.1s.1-.1.1-.2c0-.2-.1-.3-.3-.3h-.4zM48.3 89.9c0 .2-.1.4-.3.6-.2.1-.4.2-.6.2-.3 0-.5-.1-.7-.3-.2-.2-.2-.4-.2-.8v-.1c0-.2 0-.4.1-.6.1-.2.2-.3.3-.4.1-.1.3-.1.5-.1.3 0 .5.1.6.2.1.1.2.3.3.6h-.4c0-.1-.1-.2-.1-.3-.1-.1-.2-.1-.3-.1-.1 0-.3.1-.3.2-.2 0-.2.2-.2.4v.2c0 .2 0 .4.1.5.1.1.2.2.3.2.1 0 .2 0 .3-.1.1-.1.1-.2.1-.3h.5z",
    fill: "#D5E362"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9 67.4a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4zM58.8 66.6a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8zM53.2 66a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6z",
    fill: "#102834"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 25h13.8c7.9 0 14.3 6.4 14.3 14.2 0 7.9-6.4 14.2-14.2 14.2h-2.9L73 60.7v-7.2h-1.1c-7.9 0-14.2-6.4-14.2-14.2 0-7.9 6.4-14.3 14.2-14.3z",
    fill: "url(#b-no-votes)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4 26.1h12.9c7.4 0 13.4 5.8 13.4 13s-6 13-13.4 13H72.4c-7.4 0-13.4-5.8-13.4-13s6-13 13.4-13z",
    fill: "url(#c-no-votes)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9 27.6h11.8c6.7 0 12.2 5.1 12.2 11.5 0 6.3-5.5 11.5-12.2 11.5H72.9c-6.7 0-12.2-5.1-12.2-11.5 0-6.3 5.5-11.5 12.2-11.5z",
    fill: "url(#d-no-votes)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1 37.8h3.4v2.4h-3.4V44h-2.6v-3.8h-3.4v-2.4h3.4v-3.6h2.6v3.6z",
    fill: "#B7C54A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4 20h-10C24.6 20 20 24.6 20 30.4c0 5.7 4.6 10.4 10.4 10.4h2.1l7.1 5.3v-5.3h.8c5.7 0 10.4-4.6 10.4-10.4-.1-5.8-4.7-10.4-10.4-10.4z",
    fill: "url(#e-no-votes)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1 20.8h-9.4c-5.4 0-9.7 4.2-9.7 9.5 0 5.2 4.3 9.4 9.7 9.4h9.4c5.4 0 9.7-4.2 9.7-9.4 0-5.3-4.4-9.5-9.7-9.5z",
    fill: "url(#f-no-votes)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7 21.9h-8.6c-4.9 0-8.9 3.7-8.9 8.3 0 4.6 4 8.3 8.9 8.3h8.6c4.9 0 8.9-3.7 8.9-8.3-.1-4.5-4-8.3-8.9-8.3z",
    fill: "url(#g-no-votes)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6 31.8c0-.5.1-.9.2-1.2.1-.3.3-.6.7-.9.2-.3.5-.5.6-.7.1-.2.2-.4.2-.6 0-.6-.3-.9-.8-.9-.3 0-.5.1-.6.2-.2.2-.2.4-.2.7H33c0-.7.2-1.2.7-1.6.4-.4 1-.6 1.8-.6.7 0 1.3.2 1.7.5.4.4.6.9.6 1.5 0 .3-.1.6-.2.8-.1.3-.4.6-.7.9l-.4.4c-.3.3-.4.6-.5.9v.3h-1.4v.3zm-.2 1.6c0-.2.1-.4.2-.6.2-.2.4-.2.6-.2.2 0 .5.1.6.2.2.2.2.3.2.6 0 .2-.1.4-.2.6-.2.2-.4.2-.6.2-.3 0-.5-.1-.6-.2-.1-.2-.2-.4-.2-.6z",
    fill: "#B7C54A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a-no-votes",
    x1: 47.986,
    y1: 99.244,
    x2: 73.391,
    y2: 52.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#152D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#243D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#3D5662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465F6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b-no-votes",
    x1: 88.985,
    y1: 59.405,
    x2: 71.966,
    y2: 25.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#C4D255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#D9E766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#E6F470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c-no-votes",
    x1: 90.893,
    y1: 48.608,
    x2: 69.359,
    y2: 31.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#E6F470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#D9E766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#C4D255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7C54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d-no-votes",
    x1: 91.864,
    y1: 49.374,
    x2: 65.837,
    y2: 28.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#C4D255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#D9E766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#E6F470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e-no-votes",
    x1: 45.935,
    y1: 43.108,
    x2: 26.4,
    y2: 19.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#C4D255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#D9E766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#E6F470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-no-votes",
    x1: 26.618,
    y1: 37.155,
    x2: 42.265,
    y2: 24.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#C4D255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#D9E766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#E6F470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g-no-votes",
    x1: 25.912,
    y1: 37.712,
    x2: 44.825,
    y2: 22.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#E6F470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#D9E766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#C4D255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7C54A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVotes);
export default __webpack_public_path__ + "static/media/no-votes.0ae1f450bd34d7040581468596a063ac.svg";
export { ForwardRef as ReactComponent };